(() => {
  const TEMPLATE_ID = 'CartConversionTemplate';
  const DEFAULT_THRESHOLD = 10000;
  let refreshTimer;
  let refreshing = false;

  const formatMoney = (cents, currency = 'EUR') => {
    try {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2)} €`;
    }
  };

  const getCart = async () => {
    const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Impossibile leggere il carrello');
    return response.json();
  };

  const buildExtras = (cart) => {
    const template = document.getElementById(TEMPLATE_ID);
    if (!template) return null;

    const fragment = template.content.cloneNode(true);
    const root = fragment.querySelector('.cart-conversion');
    if (!root) return null;

    const threshold = Number(root.dataset.freeShippingThreshold || DEFAULT_THRESHOLD);
    const remaining = Math.max(0, threshold - cart.total_price);
    const progress = Math.min(100, Math.max(0, (cart.total_price / threshold) * 100));
    const message = root.querySelector('[data-cart-goal-message]');
    const bar = root.querySelector('[data-cart-goal-bar]');

    if (message) {
      if (remaining > 0) {
        message.innerHTML = `Ti mancano <strong>${formatMoney(remaining, cart.currency || 'EUR')}</strong> per la spedizione gratuita`;
      } else {
        message.innerHTML = '<strong>Hai ottenuto la spedizione gratuita</strong>';
      }
    }
    if (bar) bar.style.width = `${progress}%`;

    const variantIds = new Set((cart.items || []).map((item) => String(item.variant_id)));
    root.querySelectorAll('[data-cart-upsell-item]').forEach((item) => {
      if (variantIds.has(String(item.dataset.variantId))) item.remove();
    });

    const upsell = root.querySelector('[data-cart-upsell]');
    if (upsell && !upsell.querySelector('[data-cart-upsell-item]')) upsell.remove();

    return root;
  };

  const updateDrawerState = () => {
    const drawer = document.querySelector('cart-drawer');
    document.body.classList.toggle('cart-drawer-open', Boolean(drawer?.classList.contains('active')));
  };

  const injectExtras = async () => {
    if (refreshing) return;
    refreshing = true;
    try {
      updateDrawerState();
      const cart = await getCart();

      const drawerTarget = document.querySelector('#CartDrawer-CartItems');
      if (drawerTarget && !drawerTarget.querySelector(':scope > .cart-conversion')) {
        const extras = buildExtras(cart);
        if (extras) drawerTarget.append(extras);
      }

      const pageTarget = document.querySelector('#main-cart-footer .js-contents');
      if (pageTarget && !pageTarget.querySelector(':scope > .cart-conversion')) {
        const extras = buildExtras(cart);
        if (extras) pageTarget.prepend(extras);
      }
    } catch (error) {
      console.warn('[Cart conversion]', error);
    } finally {
      refreshing = false;
    }
  };

  const scheduleRefresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(injectExtras, 100);
  };

  const addUpsell = async (button) => {
    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    const originalLabel = button.querySelector('span')?.textContent || 'Aggiungi';
    button.disabled = true;
    if (button.querySelector('span')) button.querySelector('span').textContent = 'Aggiungo…';

    try {
      const drawer = document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        formData.append('sections', drawer.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData,
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Prodotto non disponibile');

      if (document.querySelector('#main-cart-footer')) {
        window.location.reload();
        return;
      }

      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents(data);
        drawer.classList.remove('is-empty');
      }
      scheduleRefresh();
    } catch (error) {
      console.warn('[Cart conversion]', error);
      if (button.querySelector('span')) button.querySelector('span').textContent = 'Non disponibile';
      setTimeout(() => {
        if (button.querySelector('span')) button.querySelector('span').textContent = originalLabel;
        button.disabled = false;
      }, 1800);
      return;
    }

    button.disabled = false;
    if (button.querySelector('span')) button.querySelector('span').textContent = originalLabel;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-upsell-add]');
    if (!button) return;
    event.preventDefault();
    addUpsell(button);
  });

  const observer = new MutationObserver(() => {
    updateDrawerState();
    scheduleRefresh();
  });

  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    scheduleRefresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
